
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/unity',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/unity/',
            getPage: () => import(
              /* webpackChunkName: "unity" */
              '/work/unity-sdk/_site_tmp/_unity.js'
            ),
            
            
          },{
            path: '/unity/maps/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps" */
              '/work/unity-sdk/_site_tmp/_unity_maps.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/astronaut-game/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-astronaut-game" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_astronaut-game.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/city-simulator/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-city-simulator" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_city-simulator.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/data-explorer/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-data-explorer" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_data-explorer.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/iconic-buildings/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-iconic-buildings" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_iconic-buildings.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/location-based-game/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-location-based-game" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_location-based-game.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/poi-placement/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-poi-placement" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_poi-placement.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/replace-features/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-replace-features" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_replace-features.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/tabletop-ar/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-tabletop-ar" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_tabletop-ar.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/traffic-and-directions/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-traffic-and-directions" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_traffic-and-directions.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/world-scale-ar/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-world-scale-ar" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_world-scale-ar.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/world-scale-manual-align-ar/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-world-scale-manual-align-ar" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_world-scale-manual-align-ar.js'
            ),
            
            
          },{
            path: '/unity/maps/examples/zoomable-map/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-examples-zoomable-map" */
              '/work/unity-sdk/_site_tmp/_unity_maps_examples_zoomable-map.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/add-markers/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-add-markers" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_add-markers.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/attribution/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-attribution" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_attribution.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/custom-maps/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-custom-maps" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_custom-maps.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/location-based-games/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-location-based-games" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_location-based-games.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/map-features/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-map-features" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_map-features.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/migrate-version/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-migrate-version" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_migrate-version.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-pricing" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_pricing.js'
            ),
            
            
          },{
            path: '/unity/maps/guides/styling/',
            getPage: () => import(
              /* webpackChunkName: "unity-maps-guides-styling" */
              '/work/unity-sdk/_site_tmp/_unity_maps_guides_styling.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };